import { OtherMessages, UseThreadMessages, UseThreadMessagesNew } from '../types'

export const emptyMessagesWidget: MessagingWidget = {
  data: {
    notificationVolume: 0,
    tab: null,
    // thread: null,
  },
  searchQuery: '',
  tabsVisible: false,
  updateSearchQuery: () => {},
  creatingNewThread: false,
  setCreatingNewThread: () => {},
  loading: false,
  clearSearchResult: () => {},
  searchResult: null,
  setSearchResult: () => {},
  localNotificationVolume: null,
  updateLocalNotificationVolume: () => {},
  error: null,
  update: async () => ({ error: 'No widget' }),
  searchMyThreads: async () => [],
  threadSelection: null,
  setThreadSelection: () => {},
}

export const emptyUseMyThreads: UseMyThreads = {
  data: [],
  selectedTabThreads: [],
  deepSearchLoading: false,
  deepSearchResults: null,
  deepSearchThreads: () => {},
  numUnreadThreads: 0,
  loading: false,
  error: null,
}

const emptyOtherMessages: OtherMessages = {
  fetching: false,
  loading: false,
  error: null,
  hasMore: false,
  fetchMore: () => {},
}

export const emptyUseThreadMessages: UseThreadMessages = {
  data: [],
  loading: false,
  error: null,
  earlierMessages: emptyOtherMessages,
  laterMessages: emptyOtherMessages,
  selectedMessage: null,
  selectMessage: () => {},
}

export const emptyUseThreadMessagesNew: UseThreadMessagesNew = {
  data: [],
  selectedMessage: null,
  selectMessage: () => {},
  loadingBaseGroups: false,
  hasNextGroup: false,
  hasPreviousGroup: false,
  loadingNextGroup: false,
  loadingPreviousGroup: false,
  fetchNextGroup: async () => null,
  fetchPreviousGroup: async () => null,
  loadingToday: false,
  fetchBaseGroups: async () => {},
}

import { colors, NotificationSoundId } from '@hb/shared'
import bikebell from '../../sounds/bikebell.mp3'
import chime from '../../sounds/chime.mp3'
import ding from '../../sounds/ding.mp3'
import sleighbell from '../../sounds/sleighbell.mp3'
import { MessagingWidget } from '../types/MessagingWidget'
import { UseMyThreads } from '../types/UseMyThreads'

export const notificationSounds: Record<NotificationSoundId, string> = {
  ding,
  'bike-bell': bikebell,
  chime,
  'sleigh-bell': sleighbell,
}

export const NOTIFICATION_SOUNDS: { id: NotificationSoundId; name: string }[] = [
  { id: 'ding', name: 'Ding' },
  { id: 'bike-bell', name: 'Bike Bell' },
  { id: 'chime', name: 'Chime' },
  { id: 'sleigh-bell', name: 'Sleigh Bell' },
]

export const notificationSoundGradients: Record<NotificationSoundId, string> = {
  // green
  ding: `linear-gradient(60deg, ${colors.green.hex} 0%, ${colors.lightgreen.hex} 100%)`,
  // blue
  chime: `linear-gradient(60deg, ${colors.blue.hex} 0%, ${colors.lightblue.hex} 100%)`,
  // purple
  'bike-bell': `linear-gradient(60deg, ${colors.purple.hex} 0%, ${colors.lightpurple.hex} 100%)`,
  // christmas
  'sleigh-bell': `linear-gradient(60deg, ${colors.red.hex} 0%, ${colors.green.hex} 100%)`,
}

export const defaultNotificationSound: NotificationSoundId = 'ding'
